var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoundedArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4983 5.8335C10.9199 5.8335 11.3233 6.02766 11.6033 6.3685L15.1141 10.6168C15.5341 11.126 15.6183 11.8485 15.3299 12.4593C15.0758 12.9985 14.5699 13.3335 14.0091 13.3335L6.98744 13.3335C6.4266 13.3335 5.92077 12.9985 5.6666 12.4593C5.37827 11.8485 5.46244 11.126 5.8816 10.6177L9.39327 6.3685C9.67327 6.02766 10.0766 5.8335 10.4983 5.8335Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundedArrow);
export default __webpack_public_path__ + "static/media/RoundedArrow.68044eb7d2977265ef71802e5e4dbbce.svg";
export { ForwardRef as ReactComponent };